import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const userAPI = {
  getAllUsers: async (params: { page?: number; limit?: number; search?: string; gender?: string }) => {
    const response = await apiService.get(API_ENDPOINTS.USER.GET_ALL, { params });
    return response.data;
  },
  
  getUserDetails: async (userId: string) => {
    const response = await apiService.get(`${API_ENDPOINTS.USER.GET_BY_ID}/${userId}`);
    return response.data;
  },
  
  deleteUser: async (userId: string) => {
    const response = await apiService.delete(`${API_ENDPOINTS.USER.DELETE}/${userId}`);
    return response.data;
  },
};